// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 19 ? "__federation_expose_GlobalNavigation" : chunkId) + "." + {"19":"a96e4bec53a3d5cb","27":"7abbe89361794503","195":"7abbe89361794503","259":"7abbe89361794503","578":"fa6f5555edd16708"}[chunkId] + ".css";
};